var map = {
	"./articles/1-detail.jpg": "f956",
	"./articles/1-preview.jpg": "7351",
	"./articles/10-detail.jpeg": "c9eb",
	"./articles/10-preview.jpeg": "f362",
	"./articles/11-detail.jpeg": "7718",
	"./articles/11-preview.jpg": "c9e6",
	"./articles/11-preview.webp": "74d8",
	"./articles/12-detail.png": "bbf0",
	"./articles/12-preview.jpg": "c8cc",
	"./articles/13-detail.webp": "00ef",
	"./articles/14-detail.webp": "d586",
	"./articles/15-detail.webp": "0cca",
	"./articles/16-detail.webp": "bd13",
	"./articles/17-detail.jpg": "983a",
	"./articles/18-detail.png": "6b67",
	"./articles/2-detail.jpg": "bdd0",
	"./articles/2-preview.jpg": "46ab",
	"./articles/3-detail.jpg": "228a",
	"./articles/3-preview.jpg": "1905",
	"./articles/4-detail.jpg": "b54c",
	"./articles/4-preview.jpg": "4267",
	"./articles/5-detail.jpg": "86d5",
	"./articles/5-preview.jpg": "9abf",
	"./articles/6-detail.jpg": "4cc9",
	"./articles/6-preview.jpg": "4bc6",
	"./articles/7-preview.png": "003e",
	"./articles/8-preview.jpg": "02e1",
	"./articles/9-preview.jpg": "4232",
	"./jpg/fund-banner2.jpg": "bcfd",
	"./partner/els.svg": "a5bf",
	"./partner/nalogia.svg": "3523",
	"./partner/newFormation.png": "f606",
	"./partner/rossG.svg": "44bb",
	"./png/es-banner-bekr.png": "2783",
	"./png/es-banner-cube-1.png": "6aaf",
	"./png/es-banner-cube-2-tablet.png": "e8fc",
	"./png/es-banner-cube-2.png": "ee3b",
	"./png/es-banner-desk.png": "2934",
	"./png/es-banner-mob.png": "c504",
	"./png/es-banner-tablet.png": "c51a",
	"./png/es-qr-code.png": "d6d8",
	"./png/fund-banner.png": "5444",
	"./png/main-banner.png": "63c4",
	"./svg/cyberDictation.svg": "8ae5",
	"./svg/es-logo.svg": "565e",
	"./svg/fundBannerDecor.svg": "c830",
	"./svg/fundLodoB.svg": "9766",
	"./svg/fundLogoL.svg": "aa5d",
	"./svg/pravovoiLogo.svg": "5409",
	"./svg/sliderControl.svg": "7bba",
	"./svg/sliderControlColor.svg": "288c",
	"./svg/vppdLogo.svg": "fa33",
	"./team/Bekrenev.png": "6ff2",
	"./team/Brusenskiy.png": "48ba",
	"./team/Murylev.png": "896b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";